module.exports = __webpack_public_path__ + "cdfb211655d90faeaeddd99df0d12beb.svg";